module.exports = __webpack_public_path__ + "static/media/Rectangle 85 (3).51d5b015.jpg";